/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSortDescendingLetters = createReactComponent("outline", "sort-descending-letters", "IconSortDescendingLetters", [["path", { "d": "M15 21v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4", "key": "svg-0" }], ["path", { "d": "M19 10h-4l4 -7h-4", "key": "svg-1" }], ["path", { "d": "M4 15l3 3l3 -3", "key": "svg-2" }], ["path", { "d": "M7 6v12", "key": "svg-3" }]]);

export { IconSortDescendingLetters as default };
//# sourceMappingURL=IconSortDescendingLetters.mjs.map
